module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAP1JREFUOE+9lKFuAjEcxn+fmyCZRUwgECyZ4BVQvAAGgbhkEnvJHoElCHAYgljmEAgegQSDJGECgUAiJ0lu6XKX9C5tcwfLmtS0X3/9vvbfij9qyjhJkrwAH0DbwY6AR0lT37426AC0PEIDWgBjSbFLY4OSQMoMZCQTIJZ0tfW3gMz6JdC3YWVBr6mTmuViBQwkfZuxsqA18Al0C/E3kuZVQEZ7SnuOJanjAxmrl8LODe+1S7+pXNHeJL1b9fUAbD31hQKgSrX+L6AzcAzYagJP2XzI0QiYAXXAnE+x9YBhGdDdZxR6tD74l6Tn4vWHvhEXaAdEkvY5UKU8DvEPqpNfE+6Is74AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/备忘录.png
// module id = hkJl
// module chunks = 103